import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 配置文件
import config from '@/config/js/config.js'
Vue.prototype.$config = config
//编码不渲染标签
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

//uuid
import { nanoid } from "nanoid";
Vue.prototype.uuid = nanoid;

import dialogUploadInfo from '@/components/dialogUploadInfo.vue';
Vue.component('DialogUploadInfo', dialogUploadInfo)
import articlePreview from '@/components/articlePreview.vue';
Vue.component('ArticlePreview', articlePreview)

import moment from 'moment';
Vue.prototype.$moment = moment;


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
